<template>
  <div class="dyCardBagHome">
    <van-form class="container" @submit="onSubmit" validate-first>
      <van-field
        v-model="form.phone"
        type="number"
        clearable
        center
        placeholder="手机号码"
      />
      <!-- :rules="[
          { required: true, message: '请填写手机号码' },
          { pattern: /^1[3456789]\d{9}$/, message: '请填写正确的手机号码' }
        ]"
        :rules="[{ required: true, message: '请填写短信验证码' }]"
      -->
      <van-field
        v-model="form.captchaCode"
        center
        clearable
        maxlength="6"
        placeholder="短信验证码"
      >
        <template #button>
          <div v-if="!timer" @click="!yzmLoading ? getCode() : ''">
            获取验证码
          </div>
          <van-count-down v-else :time="timer" @finish="timer = 0" />
        </template>
      </van-field>
      <van-button
        block
        color="#000"
        loading-text="加载中..."
        :loading="loading"
        class="redeemBtn"
        native-type="submit"
      >
        立即登录
      </van-button>
    </van-form>
  </div>
</template>

<script>
import { dyCardBagLogin, dyCardBagSendCaptcha } from '@/api/dyCardBag'
export default {
  data() {
    return {
      form: {
        phone: '',
        captchaCode: ''
      },
      loading: false,
      yzmLoading: false,
      timer: 0
    }
  },
  created() {},
  methods: {
    async getCode() {
      if (!this.form.phone) {
        this.$toast.fail('请填写手机号')
        return
      }
      try {
        this.yzmLoading = true
        await dyCardBagSendCaptcha({
          phone: this.form.phone
        })
        this.yzmLoading = false
        this.timer = 60000
      } catch ({ data }) {
        this.yzmLoading = false
      }
    },
    async onSubmit() {
      try {
        this.loading = true
        const { data } = await dyCardBagLogin(this.form)
        this.loading = false
        sessionStorage.setItem('dyCardBagToken', data)
        this.$router.push('/dyCardBag/detail')
      } catch (error) {
        console.log(error)
        this.loading = false
      }
    }
  }
}
</script>
<style lang="less" scoped>
.dyCardBagHome {
  min-height: 100vh;
  background: #ecedf0 url('~@/assets/img/dyCardBag/home.png') top center
    no-repeat;
  background-size: 100% auto;
  position: relative;
  .container {
    position: absolute;
    bottom: 8%;
    width: 90%;
    left: 5%;
    padding: 0px 23px 0px;
    box-sizing: border-box;
    border-radius: 15px;
    .van-cell {
      border-radius: 30px;
      margin-bottom: 20px;
      line-height: 30px;
      padding: 10px 22px;
    }
    :deep(.van-field__button) {
      color: #000;
    }
    .redeemBtn {
      color: #000;
      margin: 0px 0 20px;
      border-radius: 30px;
      font-size: 18px;
      height: 50px;
      line-height: 50px;
    }
  }
}
</style>
